import type { FunctionComponent } from 'react'

interface CheckedIconProps {
  color: string
}

const CheckedIcon: FunctionComponent<CheckedIconProps> = ({ color }) => {
  return (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.91821 18.6218C6.68384 18.6218 3.73071 16.9343 2.11353 14.1218C0.496338 11.3445 0.496338 7.93433 2.11353 5.12183C3.73071 2.34448 6.68384 0.621826 9.91821 0.621826C13.1174 0.621826 16.0706 2.34448 17.6877 5.12183C19.3049 7.93433 19.3049 11.3445 17.6877 14.1218C16.0706 16.9343 13.1174 18.6218 9.91821 18.6218ZM13.8909 7.96948H13.8557C14.2073 7.65308 14.2073 7.12573 13.8557 6.77417C13.5393 6.45776 13.012 6.45776 12.6956 6.77417L8.79321 10.7117L7.14087 9.05933C6.78931 8.70776 6.26196 8.70776 5.94556 9.05933C5.59399 9.37573 5.59399 9.90308 5.94556 10.2195L8.19556 12.4695C8.51196 12.821 9.03931 12.821 9.39087 12.4695L13.8909 7.96948Z"
        fill={color}
      />
    </svg>
  )
}

export default CheckedIcon
